<template>
  <div class="modal-wrap">
    <el-dialog
      :title="type === 'title' ? '保存为标题包' : '保存为描述包'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="500px"
      :append-to-body="true"
    >
      <el-form :model="formData" :rules="rules" ref="formRef" label-width="70px">
        <el-form-item prop="content" label="包名：" :rules="[{ required: true, message: '请输入包名' }]">
          <el-input placeholder="请输入包名" v-model="formData.content"> </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSavePkg">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AddModal",
  data() {
    return {
      dialogVisible: false,
      formData: {
        content: "",
      },
      rules: {},
      type: "",
      curLength: 5, //当前可以添加的标题数
    };
  },
  methods: {
    showModal(type) {
      this.type = type;
      this.formData.content = "";
      this.dialogVisible = true;
    },
    handleSavePkg() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.dialogVisible = false;
          this.$emit("confirm", this.formData.content, this.type);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.modal-wrap {
  .modal-form {
    margin-top: 16px;
    padding: 0px;
    list-style: none;
    .form-item {
      display: flex;
      .form-label {
        flex-shrink: 0;
        display: inline-block;
        width: 200px;
        text-align: right;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.65);
        padding-top: 13px;
        &.require::before {
          content: "*";
          display: inline-block;
          color: red;
          margin-right: 4px;
        }
      }
      .form-value {
        width: 100%;
        padding-top: 2px;
        .custom-wrap {
          margin-top: 10px;
        }
        /deep/ .el-radio__input.is-checked .el-radio__inner {
          color: rgba(24, 144, 255, 1);
          border-color: rgba(24, 144, 255, 1);
          background: rgba(24, 144, 255, 1);
        }
        /deep/ .el-radio__input.is-checked + .el-radio__label {
          color: rgba(24, 144, 255, 1);
        }
      }
    }
  }
}
</style>
